/**
 * created by xcc
 * 审核备注维护
 */
import React from "react";
import BaseComponent from "../../../../../base/BaseComponent";
import {Row, Col, Icon, Switch, Modal, Form, Input} from "antd";
import PageTemplate from "../../../components/pageTemplate/PageTemplate";
import {RightContent} from "./RightContent";
import "./positionAuditRemark.css";
import {message} from "../../../../../utils/message";
import {getActivityTypeData} from "../../../../newMediaMatrix/actions/actions";

export default class PositionAuditRemark extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            activityTypeData: [],
            tableData: [],
            checked: false,
            currentClickItem: {},
            visible: false
        };
    }

    componentDidMount() {
        this.getActivityTypeData();
    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;    //防止内存泄露
        };
    }

    getActivityTypeData() {
        let params = {
            pageNum: 1,
            pageSize: 10
        };
        getActivityTypeData(params,(res) => {
            let activityTypeData = [];
            if (res && res.data && res.data.length) {
                activityTypeData = res.data;
            }
            this.setState({
                activityTypeData,
                currentClickItem: activityTypeData[0]
            })
        })
    }

    renderLeft() {
        const {activityTypeData} = this.state;
        return (
            <div className={"activityType"}>
                <div className={"typeTitle"}><Icon style={{color: "#ffcd2c", marginRight: 5, paddingLeft: 24}}
                                                   type="folder" theme="filled"/>流程类型
                </div>
                <div>
                    {activityTypeData.map(item => {
                        return this.renderActivityTypeItem(item)
                    })}
                </div>
                {this.renderEditModal()}
            </div>
        )
    }

    renderActivityTypeItem(item) {
        const {currentClickItem = {}} = this.state;
        return (
            <div key={item.id} className={currentClickItem.id === item.id ? "typeContentChecked" : "typeContentNormal"}
                 style={{
                     padding: "13px 24px",
                     cursor: "pointer",
                     display: "flex",
                     justifyContent: "space-between",
                     alignItems: "center"
                 }} onClick={() => this.onClickTypeItem(item)}>
                <div><Icon style={{marginRight: 5}} type="file-text"/>{item.name}</div>
                <div style={{display: "flex", alignItems: "center"}}>
                    <Icon style={{marginRight: 5}} type="edit" onClick={(e) => this.edit(item, e)}/>
                    <Switch checkedChildren="开" unCheckedChildren="关"
                            checked={item.status === 1}
                            onChange={(checked, e) => {
                                e.stopPropagation();
                                item.status = checked ? 1 : 0;
                                this.setState({});
                                this.updateStatus(item);
                            }
                            }
                    /></div>
                </div>
        )
    }

    renderEditModal = () => {
        let {visible} = this.state;
        const {editData} = this.state;
        if (!editData) {
            return null;
        }
        const onDataChange = this.onDataChange;
        return (
            <Modal
                visible={visible}
                width={480}
                onCancel={this.handleCancel}
                onOk={this.handleOk}
                title={"编辑"}
            >
                <Form.Item
                    label={editData.name.label}
                    required={editData.name.required}
                >
                    <Input
                        value={editData.name.value}
                        onChange={e => onDataChange({name: e.target.value})}
                        placeholder={editData.name.placeholder}
                    />
                </Form.Item>
                <Form.Item
                    label={editData.code.label}
                    required={editData.code.required}
                >
                    <Input
                        value={editData.code.value}
                        onChange={e => onDataChange({code: e.target.value})}
                        placeholder={editData.code.placeholder}
                    />
                </Form.Item>
            </Modal>
        );
    }

    handleCancel = () => {
        this.setState({
            visible: false
        })
    }

    handleOk = () => {
        const {editData} = this.state;
        const data = {};
        const editDataKeys = Object.keys(editData);
        for (let i = 0; i < editDataKeys.length; i++) {
            const key = editDataKeys[i];
            data[key] = editData[key].value;
            if (editData[key].check && !editData[key].check(editData[key].value)) {
                return;
            }
        }
        this.request({
            url: "/cm-sites-media-consumer/system/activityType/edit",
            method: "post",
            contentType: 'json',
            body: {...data},
            callBack: (data)=>{
                if(data) {
                    message.success("修改成功");
                    this.state.visible = false;
                    this.getActivityTypeData();
                }else {
                    message.warning("修改失败");
                }
            }
        });
    };

    onDataChange = data => {
        const editData = this.state.editData;
        Object.keys(data).forEach(key => {
            editData[key].value = data[key];
        });
        this.setState({});
    };

    edit = (item, e) => {
        e.stopPropagation();
        this.setState({
            visible: true,
            editData: this.initData(item || {})
        })
    }

    initData(item) {
        const data = {
            id: { value: item.id || "" },
            name: {
                value: item.name || "",
                required: true,
                label: "节点名称：",
                placeholder: "请输入节点名称",
                check: value => {
                    if (!value) {
                        message.warn("节点名称不能为空！");
                        return false;
                    }
                    return true;
                }
            },
            code: {
                value: item.code || "",
                label: "节点编码：",
                required: true,
                placeholder: "请输入节点编码",
                check: value => {
                    if (!value) {
                        message.warn("节点编码不能为空！");
                        return false;
                    }
                    return true;
                }
            }
        };

        for (const key in item) {
            if (!data.hasOwnProperty(key)) {
                data[key] = { value: item[key] };
            }
        }

        return data;
    }

    validateName(value, {min, max, includesZhCN = true} = {},regTxt="") {
        let reg;
        if (includesZhCN) {
            reg = new RegExp(`^[\u9FA6-\u9FCB\u3400-\u4DB5\u4E00-\u9FA5\u25CF\u00B7_a-zA-Z0-9${regTxt}]{${min},${max}}$`);
        } else {
            reg = new RegExp(`^[_a-zA-Z0-9${regTxt}]{${min},${max}}$`);
        }
        return reg.test(value);
    }

    updateStatus(item) {
        this.request({
            url: '/cm-sites-media-consumer/system/activityType/edit',
            body: {...item},
            method: "post",
            contentType: "json",
            callBack: (res) => {
                if(res) {
                    if(res.status) {
                        message.success("已开启");
                    }else {
                        message.success("已关闭");
                    }
                }
            },
            errorCallBack: (e) => {
                console.log(e)
            },
        })
    }

    onClickTypeItem(item) {
        let that = this;
        if(that.rightContent.state.prohibitExit) {
            Modal.confirm({
                title: '检测到当前有操作没有保存，切换流程类型后当前修改数据将会丢失。是否切换！',
                content: <></>,
                okText: '确定',
                cancelText: '取消',
                onOk() {
                    that.rightContent.state.prohibitExit = false;
                    that.setState({
                        currentClickItem: item
                    });
                },
                onCancel() {
                },
            })
        }else {
            that.setState({
                currentClickItem: item
            });
        }
    }

    render() {
        const {currentClickItem = {}} = this.state;
        return (
            <>
                <PageTemplate style={{padding: 0}}>
                    <Row>
                        <Col span={4}>
                            {this.renderLeft()}
                        </Col>
                        <Col span={20}>
                            {currentClickItem.id ?
                                <RightContent match={{params: {id: currentClickItem.id}}}
                                              ref={ref => this.rightContent = ref}
                                              {...currentClickItem} cancelPageStyle={true}/> : null}
                        </Col>
                    </Row>
                </PageTemplate>
            </>
        );
    }
}